import PlaceOrderState, { PlaceOrderParameter } from "@husky-hrc/Framework/Store/Data/PlaceOrder/PlaceOrderState";
import Constants from "@husky-hrc/Utilities/Constants";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: PlaceOrderState = {
    parameter: {
        paymentMethod: "",
        poNumber: "",
        saveCard: false,
        cardHolderName: "",
        cardNumber: "",
        cardType: "",
        expirationMonth: 1,
        expirationYear: new Date().getFullYear(),
        securityCode: "",
        useBillingAddress: true,
        address1: "",
        countryId: "",
        stateId: "",
        city: "",
        postalCode: "",
        payPalToken: "",
        payPalPayerId: "",
        isPending: false,
        isAdyenDropIn: false,
        adyenPspReference: "",
        accountHolderName: "",
        accountNumber: "",
        routingNumber: "",
        payerId: "",
        maskedCardNumber: "",
    },
};

const reducer = {
    [Constants.Actions.UpdatePlaceOrderParameter]: (
        draft: Draft<PlaceOrderState>,
        action: { parameter: Partial<PlaceOrderParameter> },
    ) => {
        draft.parameter = { ...draft.parameter, ...action.parameter };
    },
    [Constants.Actions.ResetPlaceOrderParameter]: () => {
        return initialState;
    },
};

const placeOrderReducer = createTypedReducerWithImmer(initialState, reducer);
export default placeOrderReducer;

// This line is important as it adds the reducer to the reducers collection on the Store.
(reducers as any).placeOrder = placeOrderReducer;
